/* unplugin-vue-components disabled */import { render } from "./QuizPairsMatchingQuestion.vue?vue&type=template&id=84c47060&scoped=true&ts=true"
import script from "./QuizPairsMatchingQuestion.vue?vue&type=script&lang=ts"
export * from "./QuizPairsMatchingQuestion.vue?vue&type=script&lang=ts"

import "./QuizPairsMatchingQuestion.vue?vue&type=style&index=0&id=84c47060&scoped=true&lang=scss"
import "./QuizPairsMatchingQuestion.vue?vue&type=style&index=1&id=84c47060&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c47060"]])

export default __exports__